import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import { rolesListFetch } from "pages/AccessManagement/actions";
import { isEmpty, find, isArray } from "lodash";
import PropTypes from "prop-types";

const RoleDropdown = (props) => {
  const {
    RoleValue,
    setRoleValue,
    selectedId,
    roleOnChange,
    id,
    name,
    size,
    renderInput,
    showSelectAllOption,
    ...attr
  } = props;

  const dispatch = useDispatch();
  const rolesState = useSelector((state) => state.rolesState);
  const [roleList, setRoleList] = useState([]);

  const customStyles = () => ({
    control: (provided, state) => ({
      ...provided,
      borderRadius: "60px",
      border: "1px solid #ccc",
      borderColor: state.isFocused ? "#888" : "#ddd",
      backgroundColor: "#fff",
      color: "#000",
      boxShadow: state.isFocused ? provided.boxShadow : "none",
      "&:hover": {
        backgroundColor: "#f0f0f0",
        borderColor: state.isFocused ? "#888" : "#ccc",
      },
    }),
  });

  useEffect(() => {
    dispatch(rolesListFetch());
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(rolesState.rolesList)) {
      let rolesOptions = rolesState.rolesList.map((role) => ({
        value: role.id,
        label: role.name,
      }));
      setRoleList(rolesOptions);
    }
  }, [rolesState.rolesList]);

  useEffect(() => {
    if (rolesState.rolesList && !isEmpty(selectedId)) {
      if (isArray(selectedId)) {
        let selectedRoles = selectedId.map((value) =>
          find(rolesState.rolesList, ["id", value])
        );
        setRoleValue(selectedRoles);
      } else {
        let selectedRole = find(rolesState.rolesList, ["id", selectedId]);
        setRoleValue(!isEmpty(selectedRole) ? selectedRole : null);
      }
    }
  }, [rolesState.rolesList, selectedId, setRoleValue]);

  return (
    <Select
      isMulti
      value={RoleValue}
      onChange={(newValue) => {
        roleOnChange(newValue);
      }}
      options={roleList}
      placeholder="Select Roles"
      isSearchable={true}
      className="font-14 font-weight-normal"
      styles={customStyles()}
    />
  );
};

RoleDropdown.propTypes = {
  roleOnChange: PropTypes.func.isRequired,
  RoleValue: PropTypes.array,
  setRoleValue: PropTypes.func,
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  id: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.string,
  showSelectAllOption: PropTypes.bool,
};

RoleDropdown.defaultProps = {
  RoleValue: [],
  id: "role_id",
  name: "role_id",
  size: "small",
  selectedId: "",
  showSelectAllOption: true,
};

export default RoleDropdown;
